import { toJson } from '@tryiris-ai/js-types';
import { Filter } from './types.js';
import { toFilter } from './utils.js';
import type { Sorting } from '#~/device/discovery/components/selector/index.js';
import { DefaultSorting, toSorting } from '#~/device/discovery/components/selector/index.js';
import type { UsePrefState } from '#~/preferences/hooks.js';
import { usePrefState } from '#~/preferences/hooks.js';

/**
 * Audio device filter.
 *
 * @returns Active filter.
 */
export const useFilterPref = (): UsePrefState<Filter> =>
  usePrefState('audio.add.filter', Filter.All, {
    deserialize: toFilter
  });

/**
 * Audio device sorting.
 *
 * @returns Device sorting.
 */
export const useSortingPref = (): UsePrefState<Sorting> =>
  usePrefState('audio.add.sorting', DefaultSorting, {
    deserialize: toSorting,
    serialize: toJson
  });
